module.exports = __webpack_public_path__ + "static/media/genefasta.67bfca62.fasta";